<div class="content-wrapper">

    <section class="content-header">
        <h1>
            {{ editando ? 'Edição da' : 'Nova' }} Emenda Parlamentar
            <small>Preencha as informações necessárias</small>
        </h1>
        <ol class="breadcrumb">
            <li>
                <a routerLink="/home">
                    <i class="fa fa-home"></i> Home</a>
            </li>
            <li>
                <a routerLink="/emenda-parlamentar">Emendas</a>
            </li>
            <li class="active">Nova Emenda Parlamentar</li>
        </ol>
    </section>

    <br>

    <div class="col-md-12">

        <div class="box box-primary">

            <div class="panel-body">

                <h3>Identificação da emenda parlamentar</h3>
                <hr>

                <form #f="ngForm" autocomplete="off" (ngSubmit)="salvar(f)">

                    <div class="ui-g">

                        <div class="ui-g-12 ui-md-9 ui-fluid">
                            <label>Título:</label>
                            <input pInputText type="text" name="titulo" [(ngModel)]="emendaParlamentar.titulo" #nome="ngModel" required>
                        </div>

                        <div class="ui-g-12  ui-md-3 ui-fluid">
                            <label>Data de Publicação:</label>
                            <p-datepicker name="dataPublicacao" dateFormat="dd/mm/yy" [inline]="false" [readonlyInput]="false" [showIcon]="true"
                                [(ngModel)]="emendaParlamentar.dataPublicacao" #dataPublicacao="ngModel"></p-datepicker>
                        </div>

                        <div class="ui-g-12 ui-fluid">
                            <p-checkbox  name="groupname" value="SIM"  label="Pretente vincular a uma entidade(OSC)?" [(ngModel)]="selectedValues" (click)="vinculaOsc()"></p-checkbox> {{selectedValues}}
                        </div>

                        <div class="ui-g-12  ui-md-6 ui-fluid" [hidden]="!mostraSelecaoOsc">
                            <label>Escolher uma entidade: </label>
                            <p-select name="entidadeProponente" [options]="entidadesProponente" placeholder="Selecione" [filter]="true"
                                [(ngModel)]="emendaParlamentarDTO.entidadeProponente.id" (click)="setaOsc()"></p-select>
                        </div>

                        <div class="ui-g-12 ui-fluid">
                            <label>Resumo:</label>
                            <p-editor name="resumo" [(ngModel)]="emendaParlamentar.resumo" [style]="{'height':'200px', 'background':'#fff'}"></p-editor>

                        </div>

                    </div>


                    <div class="box-footer">
                        <button type="submit" class="btn btn-primary ">Salvar</button>
                        &nbsp;
                        <a (click)="novo(f)">Limpar formulário</a>
                    </div>


                </form>

            </div>

        </div>

    </div>

</div>